/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RequestOrigin = {
    Edition: 'EDITION',
    Signup: 'SIGNUP'
} as const;
export type RequestOrigin = typeof RequestOrigin[keyof typeof RequestOrigin];


export function instanceOfRequestOrigin(value: any): boolean {
    for (const key in RequestOrigin) {
        if (Object.prototype.hasOwnProperty.call(RequestOrigin, key)) {
            // @ts-ignore
            if (RequestOrigin[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RequestOriginFromJSON(json: any): RequestOrigin {
    return RequestOriginFromJSONTyped(json, false);
}

export function RequestOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestOrigin {
    return json as RequestOrigin;
}

export function RequestOriginToJSON(value?: RequestOrigin | null): any {
    return value as any;
}

